import { getMovableEnvironmentPaths } from "@/lib/environment-path-set";
import type { EnvironmentEntryPayload } from "./payload";

/**
 * ツリー内移動の可否を判定する純粋関数。<paramref name="destinationDirPath"/> は移動先
 * ディレクトリの相対パス (ルートは "")。`getMovableEnvironmentPaths` で実際に移動処理
 * (`moveEnvironmentEntries`) が動かす対象と同じ基準 (子孫の重複を折りたたんだ後の no-op 除去) を
 * 適用するため、ここが true でも実際には何も動かない、という食い違いが起きない。以下のいずれかに
 * 該当する場合は false:
 *  - 折りたたみ・no-op 除去後に移動対象が残らない
 *  - 自分自身のパスへの移動
 *  - 自分の子孫ディレクトリへの移動 (フォルダのループ)
 */
export function canDropEnvironmentEntries(
	payload: EnvironmentEntryPayload,
	destinationDirPath: string,
): boolean {
	const movablePaths = new Set(
		getMovableEnvironmentPaths(
			payload.entries.map((entry) => entry.path),
			destinationDirPath,
		),
	);
	const movable = payload.entries.filter((entry) => movablePaths.has(entry.path));
	return (
		movable.length > 0 &&
		movable.every(
			(entry) =>
				entry.path !== destinationDirPath &&
				(entry.entryType !== "directory" || !destinationDirPath.startsWith(`${entry.path}/`)),
		)
	);
}
